import { Controller } from "@hotwired/stimulus";
import { writeTextToClipboard } from "../helpers/clipboard";

const COPIED_RESET_MS = 1500;

export default class extends Controller {
  async copy(event) {
    event.preventDefault();
    event.stopPropagation();

    const ok = await writeTextToClipboard(this.element.dataset.textToCopy);
    if (!ok) return;

    this.element.dataset.state = "copied";
    clearTimeout(this.resetTimeout);
    this.resetTimeout = setTimeout(() => {
      delete this.element.dataset.state;
    }, COPIED_RESET_MS);
  }

  disconnect() {
    clearTimeout(this.resetTimeout);
  }
}
